var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"input-header"},[_vm._v("Number")]),_c('v-text-field',{attrs:{"type":"text","min":"0","value":this.finding.questions.number.value,"hide-details":"","disabled":_vm.isNumberReadonly,"readonly":_vm.isNumberReadonly},on:{"change":_vm.handleNumberChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }